<p-card>
  <div class="flex align-items-center gap-2">
    <label class="font-bold mr-2">Site Code:</label>
    <ng-container *ngIf="!catalogSettings.isEditing; else editSiteCode">
      <span>{{ catalog.siteCode }}</span>
      <button
        pButton
        pRipple
        type="button"
        icon="fa fa-pencil"
        (click)="onEditSiteCode()"
        text
        rounded
        severity="secondary"
        [disabled]="pageVars?.isEditing"
        [outlined]="true"></button>
    </ng-container>
    <ng-template #editSiteCode>
      <input type="text" pInputText [(ngModel)]="catalogSettings.siteCode" maxlength="2" class="p-inputtext-sm" style="width: 3rem" />
      <div class="flex justify-content-between gap-2 mt-2">
        <p-button
          pRipple
          icon="fa fa-check"
          (click)="onSaveSiteCode()"
          severity="success"
          text
          rounded
          size="large"
          [outlined]="true"
          [disabled]="catalogSettings.siteCode?.length !== 2" />
        <p-button pRipple icon="fa fa-times" (click)="onCancelSiteCode()" severity="danger" text rounded size="large" />
      </div>
    </ng-template>
  </div>

  <hr />
  <p-table [value]="catalogOrderItemTypes" dataKey="id" editMode="row" class="table-sm">
    <ng-template #header>
      <tr>
        <th>Order Item Type</th>
        <th>Active</th>
        <th>Lead Time</th>
        <th>Allow Recurring</th>
        <th>Max Recurring Length</th>
      </tr>
    </ng-template>
    <ng-template #body let-rowIndex="rowIndex" let-catalogOrderItemType>
      <tr>
        <td>
          {{ catalogOrderItemType?.orderItemType?.name }}
        </td>
        <td>
          <p-toggleswitch
            [disabled]="false"
            (change)="updateCatalogOrderItemType(catalogOrderItemType)"
            [(ngModel)]="catalogOrderItemType.isActive"
            attr.data-testid="isAvailable{{ rowIndex }}" />
        </td>
        <td class="m-0 p-0">
          <p-inputnumber
            class="width-6"
            [(ngModel)]="catalogOrderItemType.leadTime"
            (ngModelChange)="updateCatalogOrderItemType(catalogOrderItemType)"
            inputId="integeronly"
            suffix=" Days"
            [useGrouping]="false"
            [allowEmpty]="true"
            [showClear]="catalogOrderItemType.isActive"
            [disabled]="!catalogOrderItemType.isActive" />
        </td>
        <td>
          <p-toggleswitch
            [disabled]="!catalogOrderItemType.isActive"
            (change)="updateCatalogOrderItemType(catalogOrderItemType)"
            [(ngModel)]="catalogOrderItemType.hasRecurringOrders"
            attr.data-testid="isAvailable{{ rowIndex }}" />
        </td>
        <td class="m-0 p-0">
          <p-inputnumber
            class="width-9"
            [(ngModel)]="catalogOrderItemType.maxRecurrenceDuration"
            (onInput)="updateCatalogOrderItemType(catalogOrderItemType)"
            inputId="integeronly"
            suffix=" Months"
            min="0"
            max="12"
            [useGrouping]="false"
            [allowEmpty]="false"
            [disabled]="!catalogOrderItemType.isActive || !catalogOrderItemType.hasRecurringOrders" />
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
